import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "./index.css";
import { jsxs, jsx } from 'react/jsx-runtime';
import { Link } from '@design-system/link';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
var RetailersBlock = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    retailerLinks = _ref.retailerLinks,
    type = _ref.type,
    label = _ref.label,
    _ref$titleOptions = _ref.titleOptions,
    titleOptions = _ref$titleOptions === void 0 ? {
      variant: 'body',
      tag: 'p',
      size: 's'
    } : _ref$titleOptions,
    onClickRetailerName = _ref.onClickRetailerName;
  return jsxs("div", Object.assign({
    ref: ref,
    className: classNames('cds-retailers', className, _defineProperty({}, "cds-retailers--".concat(type), type))
  }, {
    children: [label && jsx(Typography, Object.assign({
      id: "retailers",
      className: "cds-retailers__title"
    }, Object.assign(Object.assign({}, titleOptions), {
      content: label
    }))), jsx("ul", Object.assign({
      "aria-labelledby": "retailers",
      className: "cds-retailers__items"
    }, {
      children: retailerLinks.map(function (_ref2) {
        var _ref2$link = _ref2.link,
          _ref2$link$component = _ref2$link.component,
          LinkElement = _ref2$link$component === void 0 ? Link : _ref2$link$component,
          props = _ref2$link.props,
          titleAsText = _ref2.titleAsText,
          children = _ref2.children;
        return jsx("li", Object.assign({
          className: "cds-retailers__item"
        }, {
          children: jsxs(LinkElement, Object.assign({
            onClick: onClickRetailerName ? function () {
              return onClickRetailerName((props === null || props === void 0 ? void 0 : props.title) || '', props.href);
            } : undefined,
            className: classNames(titleAsText && 'cds-link-with-text')
          }, props, {
            children: [children, titleAsText && jsx("span", Object.assign({
              className: "cds-retailers__item__text"
            }, {
              children: props.title
            }))]
          }))
        }), props.href);
      })
    }))]
  }));
});
export { RetailersBlock };